/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Row, Col } from 'react-grid-system';
import Fade from 'react-bootstrap/Collapse'
import Table from 'react-bootstrap/Table'
import Tooltip from 'react-bootstrap/Tooltip'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Button from 'react-bootstrap/Button'
import { useNavigate, useLocation } from "react-router-dom"
import DropdownView from "../Common/DropdownView.js";
import Cookies from 'universal-cookie';
import Modal from 'react-bootstrap/Modal'
import $ from 'jquery';

const entUUIDMap = [
    { ent_id: 1, ent_uuid: "da877786-b94e-4990-b33e-9de2e0fae79f" },
    { ent_id: 2, ent_uuid: "a02c5c95-5bbd-4510-aa7b-9d41edeec541" },
    { ent_id: 3, ent_uuid: "1d84b298-b64d-11ec-869f-0050569667b5" }
]

window.onresize = function () {
    var screenWidth = window.screen.width;
    var screenHeight = window.screen.height;

    // Get the browser window size
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;

    // Get the size of the entire webpage
    const pageWidth = document.documentElement.scrollWidth;
    const pageHeight = document.documentElement.scrollHeight;

    // console.log("device width "+ screenWidth);
    // console.log("screen width " + windowWidth);
    // console.log("page width " +pageWidth);
    // Showing the sizes on the webpage
}

function retriveContent(item) {
    let m = <div></div>;
    if (item.status)
        if (item.subtle.length > 10) {
            m = <div >
                <div style={{ position: "relative", left: "40%" }}>
                    <img src={require("../../image/icon_ent_content_all.png").default} alt="all content" width="30px"  ></img></div>
                <div style={{ fontSize: "16px" }} dangerouslySetInnerHTML={{
                    __html: item.subtle.replace(/\n/g, "<br/>")
                }}></div>
            </div>
        } else {
            m = <div style={{ textAlign: "center", position: "relative", left: "40%" }}>
                <img src={require("../../image/icon_ent_content_all.png").default} alt="all content" width="30px" style={{ float: "left" }}></img>
                <div style={{ float: "left", fontSize: "20px" }}>{item.subtle}</div>
            </div>
        }
    else
        m = <div>{item.subtle}</div>

    return m;
}

function retriveContent_mobile(item) {
    let m = <div></div>;
    if (item.status) {
        m = <>
            <div style={{ position: "relative", left: "25%" }}><img src={require("../../image/icon_ent_content_all.png").default} alt="all content" width="30px" style={{ float: "left" }}></img></div>
            <OverlayTrigger
                placement="left"
                overlay={<Tooltip id="button-tooltip" style={{ position: 'relative', top: "50px" }} >
                    {item.subtle}
                </Tooltip>}
            >
                <div style={{ position: 'relative', bottom: "25px", left: "80%", width: "25px" }}>
                    {item.subtle !== "" ?
                        <div className="ellispe_shape_blue" >?</div> : <></>
                    }
                </div>
            </OverlayTrigger>
        </>
    }
    else
        m = <div>{item.subtle}</div>

    return m;
}

let ModalComponent = (props) => {
    const [agreeChecked, setAgreeChecked] = useState(false);
    const navigate = useNavigate();     // 導頁購物車
    let filmApi = process.env.REACT_APP_FILM_API;

    return (
        <Modal show={props.showDialog[props.index]} onHide={() => {
            props.showDialog[props.index] = false
            props.setShowDialog([...props.showDialog])
        }
        }>
            <Modal.Header closeButton>
                <Modal.Title>服務條款</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p style={{ whiteSpace: 'pre-wrap' }}>
                    {props.content}<br />
                    <a href={filmApi + props.contract} target="_blank" rel="noreferrer">服務使用條款.pdf</a>
                </p>
                <br />
                <input type="checkbox" name="cp_contract" checked={agreeChecked} onClick={() => setAgreeChecked(!agreeChecked)}></input>
                <span style={{ position: 'relative', left: "35%" }} onClick={() => setAgreeChecked(!agreeChecked)}></span>
                <label style={{ position: 'relative', left: "35%" }}>同意服務條款</label>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => {
                    props.showDialog[props.index] = false;
                    props.setShowDialog([...props.showDialog])
                }}>
                    關閉
                </Button>
                <Button variant="primary" disabled={!agreeChecked} onClick={() => { props.handleTOSLog(props.action, props.path, props.pathParam) }}>暸解</Button>
            </Modal.Footer>
        </Modal>
    )
}

let PlanItem = (props) => {
    const [open, setOpen] = useState([]);       // 展開列用
    const [listItems, setListItem] = useState([]);   // 基礎三個優惠方案的說明ex: 免費、價格
    const [plainItems, setPlainItem] = useState([]);  // 展開列的個優惠方案條件
    const [dropDownSelecor, setSelected] = useState([]);  // dropDown 數值
    const [entMountAry, setEntMountAry] = useState([]);  // dropDown select後mount 數值
    const [cellCount, setCellCount] = useState("25%");
    const [serviceContract, setServiceContract] = useState("");
    const [serviceContractFile, setServiceContractFile] = useState("");

    const navigate = useNavigate();     // 導頁購物車

    //tooltip用
    const [show, setShow] = useState(false);
    const target = useRef(null);

    //dialog
    const [showDialog, setShowDialog] = useState([]);
    const cookies = new Cookies();      // ＡＰＩ用access_token存取
    const inputRef = useRef();          // Anchor to 優惠方案區塊
    let location = useLocation();
    let curEnt = {};
    //curEnt = props.curEnt;
    function filterXSSScript(m) {
        var lt = /</g,
            gt = />/g,
            ap = /'/g,
            ic = /"/g;
        let result = m.toString().replace(lt, "&lt;").replace(gt, "&gt;").replace(ap, "&#39;").replace(ic, "&#34;");

        return result;
    }

    if (location.state == null)
        curEnt = props.curEnt;
    else
        curEnt = (location.state.curEnt) ? location.state.curEnt : props.curEnt;        // 目前的產品object{ent_id,ent_name}, ex : AI聲音濾鏡

    function handleChange(e) {
        // console.log(12321);
        //  setChecked(e.target.checked);
    }

    // console.log("so choose which : " + JSON.stringify(curEnt))
    // console.log(location);
    // console.log("in open =>" + open);
    const pagination = {
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
    };
    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div ></div>
        );
    }

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div ></div>
        );
    }

    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 2,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />
    };

    const handleClick = useCallback((e, entIndex) => {
        // console.log(e.target);
        // console.log("index "+ entIndex);
        // console.log($(e.target).html());
        entMountAry[entIndex] = $(e.target).html();
        setEntMountAry([...entMountAry])
    }, [/* deps */])

    // 開關collapse
    function changeState(index) {
        open[index] = !open[index];
        setOpen([...open]);
    }

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props} style={{ position: 'relative', left: "50px" }} >
            Simple tooltip
        </Tooltip>
    )

    function cellMapping(index) {
        let result = ["100%", "75%", "50%", "25%"];
        return result[index];
    }

    function handleTOSLog(action, path, pathParam) {
        if (action === "public") {
            let isComponentMounted = true;
            const fetchData = async () => {
                const apiUrl = process.env.REACT_APP_TOSLOG_API;
                let apiParams = {};
                let requestOptions = {};
                apiParams = {
                    "access_token": cookies.get("auth_access_token"),
                    "ent_id": filterXSSScript(curEnt.ent_id)
                };
                requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(apiParams)
                };

                const response = await fetch(apiUrl, requestOptions)
                const r = await response.json();

                // console.log(r.results);
                window.location.replace(path)
            }
            fetchData();
            return () => {
                isComponentMounted = false;
            }
        } else {
            navigate(path, pathParam);
            /*if (cookies.get("auth_access_token") != null && cookies.get("auth_access_token") != undefined){
                let isComponentMounted = true;
            const fetchData = async () => {
                const apiUrl = "/ENT/TOSLog";
                let apiParams={};
                let requestOptions = {};
                apiParams={
                    "access_token":cookies.get("auth_access_token"),
                    "ent_id": curEnt.ent_id
                };
                requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(apiParams)
                };
                
                const response =  await fetch("/api"+apiUrl,requestOptions)
                const r = await response.json();
                
                console.log(r.results);
                navigate(path,pathParam);
                
            }
            fetchData();
            return () => {
                isComponentMounted = false;
                }
            }else{
                navigate(path,pathParam);
            }*/
        }
    }

    useEffect(() => {
        // fetch("/apt/promoplan/"+curEnt.product)
        fetch(process.env.REACT_APP_PROMOPLAN_API + filterXSSScript(curEnt.product))
            .then(res => res.json())
            .then((result) => {
                // console.log(result);
                let composePlain = [];
                let openFlag = [];
                let promoplainTmpObj = [];

                for (var i = 0; i < result.length; i++) {
                    var plains = result[i].plain;
                    //promoplainTmpObj.push({promoplain_name:result[i].name, promoplain_price:result[i].price})
                    for (var j = 0; j < plains.length; j++) {
                        if (i === 0) {
                            openFlag[j] = true;  // 只需寫入一次，每個優惠方案的說明都是固定的
                            composePlain.push(
                                {
                                    "title": plains[j].title,
                                    "icon": plains[j].icon,
                                    "qa": plains[j].qa,
                                    "subtle": plains[j].subtle,
                                    "type": plains[j].type,
                                    "status": plains[j].status
                                });
                        }
                        var items = plains[j].sub;
                        for (var k = 0; k < items.length; k++) {
                            if (i === 0) {
                                if (k === 0) {
                                    composePlain[j]["instructions"] = [];
                                }
                                if (items[k].type === "Boolean" && items[k].status === "yes")
                                    composePlain[j]["instructions"].push({ "title": items[k].title, "qa": items[k].qa, item: [{ status: true, subtle: items[k].subtle, "range": items[k].range }] });
                                else if (items[k].type === "Boolean" && items[k].status === "no")
                                    composePlain[j]["instructions"].push({ "title": items[k].title, "qa": items[k].qa, item: [{ status: false, subtle: items[k].subtle, "range": items[k].range }] });
                                else
                                    composePlain[j]["instructions"].push({ "title": items[k].title, "qa": items[k].qa, item: [{ subtle: items[k].subtle, "range": items[k].range }] });
                            } else {
                                if (items[k].type === "Boolean" && items[k].status === "yes")
                                    composePlain[j]["instructions"][k].item.push({ status: true, subtle: items[k].subtle, "range": items[k].range });
                                else if (items[k].type === "Boolean" && items[k].status === "no")
                                    composePlain[j]["instructions"][k].item.push({ status: false, subtle: items[k].subtle, "range": items[k].range });
                                else
                                    composePlain[j]["instructions"][k].item.push({ subtle: items[k].subtle, "range": items[k].range });
                            }
                        }
                    }
                }
                // console.log("compose instruction: ");
                // console.log(composePlain);
                // console.log("current rsetPromoplainObj: " + JSON.stringify(promoplainTmpObj) );
                //props.setPromoplainObj(promoplainTmpObj);
                setPlainItem(composePlain);
                // setListItem(result);
                setOpen(openFlag);
                if (location.state != null && location.state.scroll) {
                    inputRef.current.scrollIntoView({ behavior: 'smooth' });
                }
                // console.log("current open => "+open);
            })
    }, [location]) // 當跳轉至此component路徑都會觸發useEffect

    useEffect(() => {
        let isComponentMounted = true;
        const fetchData = async () => {
            const apiUrl = process.env.REACT_APP_PROMO_API;
            let apiParams = {};
            let requestOptions = {};
            let collapsePromoObj = [];
            for (let i = 0; i < entUUIDMap.length; i++) {
                apiParams = {
                    //   "access_token":cookies.get("auth_access_token"),
                    "system_uuid": entUUIDMap[i].ent_uuid
                };
                requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(apiParams)
                };

                const response = await fetch(apiUrl, requestOptions)
                const r = await response.json();

                // console.log(r.results);
                let result = r.results;
                if (result.length > 0) {
                    let promoplainTmpObj = [];
                    collapsePromoObj.push({
                        "uuid": entUUIDMap[i].ent_id,
                        "promoplain_name": result[0].name
                    })
                    if (entUUIDMap[i].ent_id === curEnt.ent_id) {
                        // for (let i=0; i < result.length; i++){
                        //     currentPlain.push({promoplain_name:result[i].name, promoplain_price:result[i].price})            

                        // }
                        if (isComponentMounted) {
                            // console.log("r.results :"+ JSON.stringify(r.results));
                            var text = curEnt.ent_notice;
                            if (text != null && text !== undefined)
                                $("#ent_notice").html(text.replace(/\n/g, '<br/>'));

                            var serviceContractText = curEnt.ent_tos;
                            var serviceContractFileUrl = curEnt.ent_tos_file;
                            //serviceContractText = "tostest\ntrytry";
                            if (serviceContractText != null && serviceContractText !== undefined) {
                                setServiceContract(serviceContractText);
                                setServiceContractFile(serviceContractFileUrl);
                            }

                            // $("#ent_tos").html(serviceContract.replace(/\n/g,'<br/>'));
                            let tmpAry = [];
                            let dialogShowFlag = [];
                            for (let i = 0; i < r.results.length; i++) {
                                tmpAry.push(r.results[i].buy_min);
                                dialogShowFlag.push(false);
                            }
                            setEntMountAry(tmpAry);
                            setShowDialog(dialogShowFlag);
                            setCellCount(cellMapping(r.results.length));
                            setListItem(r.results);
                        }
                    }
                    // console.log("current rsetPromoplainObj: " + JSON.stringify(promoplainTmpObj) );
                    // console.log("all promo => "+JSON.stringify(collapsePromoObj));
                    if (location.state != null && location.state.scroll) {
                        inputRef.current.scrollIntoView({ behavior: 'smooth' });
                    }
                } else {
                    collapsePromoObj.push({
                        "uuid": entUUIDMap[i].ent_id,
                        "promoplain_name": ""
                    })
                }
            }
            props.setPromoplainObj(collapsePromoObj);
        }
        fetchData();
        return () => {
            isComponentMounted = false;
        }
    }, [location]) // 當跳轉至此component路徑都會觸發useEffect

    return (
        <div id="plan" ref={inputRef} style={{ "paddingLeft": "0px", "paddingRight": "0px", "marginTop": "20px" }}>
            <Row>
                <Col md={2.5}>
                    <div className="promoplan_hint_box">
                        <label className="promoplan_hint_header">說明</label>
                        <ul >
                            <li><img src={require("../../image/icon_ent_collapse_up.png").default} alt="收合" width="15%"></img>收起項目</li>
                            <li><img src={require("../../image/icon_ent_collapse_down.png").default} alt="收合" width="15%"></img>展開項目</li>
                            <li><img src={require("../../image/icon_ent_content_all.png").default} alt="all content" width="12%"></img>包含功能</li>
                            <li><img src={require("../../image/icon_ent_content_part.png").default} alt="partial content" width="12%"></img>部分功能</li>
                            <li><img src={require("../../image/icon_quest_hint.png").default} alt="hint" width="12%"></img>功能說明</li>
                        </ul>
                    </div>
                </Col>
                <Col xs={12} md={9.5}>
                    <Row >
                        {listItems.map((item, index) =>
                            <Col key={index} style={{ "margin": "-5px" }} xs={12} md={12 / listItems.length}>
                                <div className="promoplan_box flex_box label_text_center">
                                    <h4>{item.name}</h4>
                                    {listItems.length === 1 ?
                                        <>
                                            <Row>
                                                <Col xs={2}></Col>
                                                <Col xs={1} >
                                                    <div className="ellispe_shape"><div className="dollar_sign">$</div></div>
                                                </Col>
                                                <Col xs={6} ><p>{(item.price === "free" ? "免費" : "NT$" + item.price)}</p></Col>
                                            </Row>
                                            <Row><Col xs={3}></Col><Col xs={9}><div className="plain_box_caption">{item.caption}</div></Col></Row>
                                            <Row style={{ "marginTop": "10px" }}>
                                                <Col xs={2}></Col>
                                                <Col xs={1} >
                                                    <div className="ellispe_shape">
                                                        <div className="personal_sign"></div>
                                                        <div className="semi_circle"></div>
                                                    </div>
                                                </Col>
                                                <Col xs={6} ><p>說明</p></Col>
                                            </Row>
                                            <Row><Col xs={3}></Col><Col xs={8}><h5>{item.description}</h5></Col></Row>
                                        </> :
                                        <>
                                            <Row>
                                                <Col xs={1}></Col>
                                                <Col xs={2} >
                                                    <div className="ellispe_shape"><div className="dollar_sign">$</div></div>
                                                </Col>
                                                <Col xs={6} ><p>{(item.price === "free" ? "免費" : "NT$" + item.price)}</p></Col>
                                            </Row>
                                            <Row><Col xs={3}></Col><Col xs={9}><div className="plain_box_caption">{item.caption}</div></Col></Row>
                                            <Row style={{ "marginTop": "10px" }}>
                                                <Col xs={1}></Col>
                                                <Col xs={2} >
                                                    <div className="ellispe_shape">
                                                        <div className="personal_sign"></div>
                                                        <div className="semi_circle"></div>
                                                    </div>
                                                </Col>
                                                <Col xs={6} ><p>說明</p></Col>
                                            </Row>
                                            <Row><Col xs={3}></Col><Col xs={8}><h5>{item.description}</h5></Col></Row>
                                        </>
                                    }
                                    <Row className="subscript_area">
                                        {item.buy_min === 1 && item.buy_max === 1 ?
                                            <Col xs={3}></Col> :
                                            <>
                                                <Col xs={1}></Col>
                                                <Col xs={3} >
                                                    <DropdownView style={{ color: "black", fontSize: "25px" }} data={{ min: item.buy_min, max: item.buy_max, index: index }} handleClick={handleClick} />
                                                </Col>
                                            </>
                                        }

                                        {item.buy_min === 1 && item.buy_max === 1 ?
                                            <Col style={{ cursor: "pointer" }} xs={9} >
                                                {(item.price === 0 && curEnt.product === "voicefilter") ?
                                                    <>
                                                        <ModalComponent showDialog={showDialog} setShowDialog={setShowDialog} content={serviceContract} contract={serviceContractFile} index={index} action="public" handleTOSLog={handleTOSLog} path={process.env.REACT_APP_OFFICIAL_VOICEFILTER}></ModalComponent>
                                                        <img disabled = "disabled" src={require("../../image/btn_promo.png").default} alt="instruction" width="50%" height="40px"

                                                            onClick={() => {
                                                              //  showDialog[index] = true;
                                                              //  setShowDialog([...showDialog]);
                                                            }}>
                                                        </img>

                                                        <div disabled="disabled" onClick={() => {
                                                           // showDialog[index] = true;
                                                            //setShowDialog([...showDialog]);
                                                            // window.location.replace("https://voicefilter-stg.ai.hinet.net/index.html?from=h") 
                                                        }}>
                                                            {((cookies.get("auth_access_token") === undefined || cookies.get("auth_access_token") === "") ? "立即體驗" : "立即體驗")
                                                            }</div>
                                                    </>
                                                    :
                                                    <>
                                                        <ModalComponent showDialog={showDialog} setShowDialog={setShowDialog} index={index} action="cart" content={serviceContract} contract={serviceContractFile} handleTOSLog={handleTOSLog} path={"/cart/" + curEnt.product} pathParam={{ state: { plainInfo: item, plain: plainItems[index], page: 1, amount: 1, ent_id: curEnt.ent_id } }}></ModalComponent>
                                                        <img disabled = "disabled"  src={require("../../image/btn_promo.png").default} alt="instruction" width="50%" height="40px"

                                                            onClick={() => {
                                                             //   showDialog[index] = true;
                                                             //   setShowDialog([...showDialog]);
                                                            }}>
                                                        </img>
                                                        <div onClick={() => {
                                                          //  showDialog[index] = true;
                                                          //  setShowDialog([...showDialog]);
                                                        }}>
                                                            {((cookies.get("auth_access_token") === undefined || cookies.get("auth_access_token") === "") ? "登入訂閱" : "立即訂閱")}</div>
                                                    </>
                                                }
                                            </Col> :
                                            <>
                                                <ModalComponent showDialog={showDialog} setShowDialog={setShowDialog} index={index} action="cart" content={serviceContract} contract={serviceContractFile} handleTOSLog={handleTOSLog} path={"/cart/" + curEnt.product} pathParam={{ state: { plainInfo: item, plain: plainItems[index], page: 1, amount: entMountAry[index], ent_id: curEnt.ent_id } }}></ModalComponent>
                                                <Col style={{ cursor: "pointer" }} xs={7} ><img disabled = "disabled"  src={require("../../image/btn_promo.png").default} alt="instruction" width="70%" height="40px"
                                                    onClick={() => {
                                                      //  showDialog[index] = true;
                                                      //  setShowDialog([...showDialog]);
                                                    }}>
                                                </img>
                                                    <div style={{ width: "70%" }} onClick={() => {
                                                      //  showDialog[index] = true;
                                                       // setShowDialog([...showDialog]);
                                                    }

                                                    }>{(cookies.get("auth_access_token") === undefined || cookies.get("auth_access_token") === "") ? "登入訂閱" : "立即訂閱"}</div>
                                                </Col>
                                            </>
                                        }
                                    </Row>
                                </div>
                            </Col>
                        )}
                    </Row>
                </Col>
            </Row>

            {window.matchMedia("(min-width: 765px)").matches ?
                plainItems.map((plainItem, index) =>
                    <div key={index} style={{ marginBottom: "10px", marginTop: "20px" }}>
                        <Row className="collapse_header label_text_white label_text_left">
                            <Col xs={.5} >
                                {(open[index]) ?
                                    <img onClick={() => changeState(index)} src={require("../../image/" + plainItem.icon).default} alt="instruction" width="35px" height="35px"></img> :
                                    <img onClick={() => changeState(index)} src={require("../../image/" + plainItem.icon).default} alt="instruction" width="35px" height="35px"></img>}
                            </Col>
                            <Col xs={2.5} onClick={() => changeState(index)} aria-controls="example-collapse-text" aria-expanded={open[index]} style={{ height: "40px" }}>
                                <h5>{plainItem.title}</h5>
                                <OverlayTrigger
                                    placement="right"
                                    overlay={<Tooltip id="button-tooltip" style={{ position: 'absolute', top: "-50px" }} >
                                        {plainItem.qa}
                                    </Tooltip>}
                                >
                                    <div style={{ position: 'relative', bottom: "35px", left: "90%", width: "25px" }}>
                                        {plainItem.qa !== "" ?
                                            <div className="ellispe_shape_white" >?</div> : <></>
                                        }
                                    </div>
                                </OverlayTrigger>
                            </Col>
                            <Col xs={9}>
                                <Row>
                                    {listItems.map((item, index) =>
                                        <Col key={index} xs={12 / listItems.length}>
                                            {retriveContent(plainItem)}
                                        </Col>
                                    )}
                                </Row>
                            </Col>
                            <Col xs={1} style={{ position: 'relative', bottom: "30px", left: "90%" }}>
                                {(open[index]) ?
                                    <img onClick={() => changeState(index)} src={require("../../image/icon_collapse_up_white.png").default} alt="instruction" width="30px" height="20px"></img> :
                                    <img onClick={() => changeState(index)} src={require("../../image/icon_collapse_down_white.png").default} alt="instruction" width="30px" height="20px"></img>}
                            </Col>
                        </Row>
                        <Fade in={open[index]}>
                            <div id="example-collapse-text" className="collapse_content label_text_black">
                                <Table>
                                    <tbody>
                                        {(plainItem.instructions !== undefined && plainItem.instructions != null) ?
                                            plainItem.instructions.map((instructionItem, index) =>
                                                <tr key={index} style={{ textAlign: "center" }}>
                                                    <td style={{ width: "25%" }}>
                                                        <h6>{instructionItem.title}</h6>
                                                        <OverlayTrigger
                                                            placement="right"
                                                            overlay={<Tooltip id="button-tooltip" style={{ position: 'absolute', top: "-50px" }} >
                                                                {instructionItem.qa}
                                                            </Tooltip>}
                                                        >
                                                            <div style={{ position: 'relative', bottom: "30px", left: "95%", width: "25px" }}>
                                                                {instructionItem.qa !== "" ?
                                                                    <div className="ellispe_shape_blue" >?</div> : <></>
                                                                }
                                                            </div>
                                                        </OverlayTrigger>
                                                    </td>
                                                    {instructionItem.item.map((item, index) =>
                                                        <td key={index} style={{ width: cellCount }}>{retriveContent(item)}</td>
                                                    )}
                                                </tr>
                                            ) :
                                            <></>
                                        }
                                    </tbody>
                                </Table>
                            </div>
                        </Fade>
                    </div>
                ) : plainItems.map((plainItem, index) =>
                    <div key={index} style={{ marginBottom: "10px", marginTop: "20px" }}>
                        <Row className="collapse_header label_text_white label_text_left">
                            <Col className="hichu">
                                <Row style={{ height: "30px" }}>
                                    <Col xs={.5} >
                                        {(open[index]) ?
                                            <img style={{ position: 'relative', top: '5px' }} onClick={() => changeState(index)} src={require("../../image/" + plainItem.icon).default} alt="instruction" width="20px" height="20px"></img> :
                                            <img style={{ position: 'relative', top: '5px' }} onClick={() => changeState(index)} src={require("../../image/" + plainItem.icon).default} alt="instruction" width="20px" height="20px"></img>}
                                    </Col>
                                    <Col xs={6.5} onClick={() => changeState(index)} aria-controls="example-collapse-text" aria-expanded={open[index]} style={{ height: "40px" }}>
                                        <h4>{plainItem.title}</h4>
                                        <OverlayTrigger
                                            placement="bottom"
                                            overlay={<Tooltip id="button-tooltip" style={{ position: 'absolute', top: "-50px" }} >
                                                {plainItem.qa}
                                            </Tooltip>}
                                        >
                                            <div style={{ position: 'relative', bottom: "30px", left: "95%", width: "25px" }}>
                                                {plainItem.qa !== "" ?
                                                    <div className="ellispe_shape_white" >?</div> : <></>
                                                }
                                            </div>
                                        </OverlayTrigger>
                                    </Col>
                                    <Col xs={2}></Col>
                                    <Col xs={1} >
                                        {(open[index]) ?
                                            <img style={{ position: 'relative', top: '5px' }} onClick={() => changeState(index)} src={require("../../image/icon_collapse_up_white.png").default} alt="instruction" width="20px" height="15px"></img> :
                                            <img style={{ position: 'relative', top: '5px' }} onClick={() => changeState(index)} src={require("../../image/icon_collapse_down_white.png").default} alt="instruction" width="20px" height="15px"></img>}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={3}></Col>
                                    {listItems.map((item, index) =>
                                        <Col key={index} xs={9 / listItems.length} style={{ padding: "0px " }}>
                                            <div style={{ color: 'black', textAlign: "center" }}>{item.name}</div>
                                        </Col>
                                    )}
                                </Row>
                            </Col>
                        </Row>
                        <Fade in={open[index]}>
                            <div id="example-collapse-text" className="collapse_content label_text_black">
                                <Table>
                                    <tbody>
                                        {(plainItem.instructions !== undefined && plainItem.instructions != null) ?
                                            plainItem.instructions.map((instructionItem, index) =>
                                                <tr key={index} style={{ textAlign: "center" }}>
                                                    <td style={{ width: "20%" }}>
                                                        <h5>{instructionItem.title}</h5>
                                                        <OverlayTrigger
                                                            placement="right"
                                                            overlay={<Tooltip id="button-tooltip" style={{ position: 'absolute', top: "-50px" }} >
                                                                {instructionItem.qa}
                                                            </Tooltip>}
                                                        >
                                                            <div style={{ position: 'relative', bottom: "30px", left: "95%", width: "25px" }}>
                                                                {instructionItem.qa !== "" ?
                                                                    <div className="ellispe_shape_blue" >?</div> : <></>
                                                                }
                                                            </div>
                                                        </OverlayTrigger>
                                                    </td>
                                                    {instructionItem.item.map((item, index) =>
                                                        <td key={index} style={{ width: "25%" }}>{retriveContent_mobile(item)}</td>
                                                    )}
                                                </tr>
                                            ) :
                                            <></>
                                        }
                                    </tbody>
                                </Table>
                            </div>
                        </Fade>
                    </div>
                )}
            {window.matchMedia("(min-width: 765px)").matches ?
                <>
                    <Row>
                        <Col xs={2.5}>
                            <></>
                        </Col>
                        <Col xs={9.5}>
                            <Row >
                                {listItems.map((item, index) =>
                                    <Col key={index} style={{ "margin": "-5px" }}>
                                        <div className="promoplan_box flex_box label_text_center">
                                            <h4>{item.name}</h4>
                                            {listItems.length === 1 ?
                                                <>
                                                    <Row>
                                                        <Col xs={2}></Col>
                                                        <Col xs={1} >
                                                            <div className="ellispe_shape"><div className="dollar_sign">$</div></div>
                                                        </Col>
                                                        <Col xs={6} ><p>{(item.price === "free" ? "免費" : "NT$" + item.price)}</p></Col>
                                                    </Row>
                                                    <Row><Col xs={3}></Col><Col xs={9}><div className="plain_box_caption">{item.caption}</div></Col></Row>
                                                    <Row style={{ "marginTop": "10px" }}>
                                                        <Col xs={2}></Col>
                                                        <Col xs={1} >
                                                            <div className="ellispe_shape">
                                                                <div className="personal_sign"></div>
                                                                <div className="semi_circle"></div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={6} ><p>說明</p></Col>
                                                    </Row>
                                                    <Row><Col xs={3}></Col><Col xs={8}><h5>{item.description}</h5></Col></Row>
                                                </> :
                                                <>
                                                    <Row>
                                                        <Col xs={1}></Col>
                                                        <Col xs={2} >
                                                            <div className="ellispe_shape"><div className="dollar_sign">$</div></div>
                                                        </Col>
                                                        <Col xs={6} ><p>{(item.price === "free" ? "免費" : "NT$" + item.price)}</p></Col>
                                                    </Row>
                                                    <Row><Col xs={3}></Col><Col xs={9}><div className="plain_box_caption">{item.caption}</div></Col></Row>
                                                    <Row style={{ "marginTop": "10px" }}>
                                                        <Col xs={1}></Col>
                                                        <Col xs={2} >
                                                            <div className="ellispe_shape">
                                                                <div className="personal_sign"></div>
                                                                <div className="semi_circle"></div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={6} ><p>說明</p></Col>
                                                    </Row>
                                                    <Row>
                                                        <Col xs={3}></Col>
                                                        <Row><Col xs={3}></Col><Col xs={8}><h5>{item.description}</h5></Col></Row>
                                                    </Row>
                                                </>
                                            }
                                            <Row style={{ "position": "absolute", "bottom": "0", "width": "100%" }}>
                                                {item.buy_min === 1 && item.buy_max === 1 ?
                                                    <Col xs={3}></Col> :
                                                    <>
                                                        <Col xs={1}></Col>
                                                        <Col xs={3} >
                                                            <DropdownView style={{ color: "black", fontSize: "25px" }} data={{ min: item.buy_min, max: item.buy_max, index: index }} handleClick={handleClick} />
                                                        </Col>
                                                    </>
                                                }
                                                {item.buy_min === 1 && item.buy_max === 1 ?
                                                    <Col style={{ cursor: "pointer" }} xs={9} >
                                                        {(item.price === 0 && curEnt.product === "voicefilter") ?
                                                            <>
                                                                <img src={require("../../image/btn_promo.png").default} alt="instruction" width="50%" height="40px"
                                                                    onClick={() => {
                                                                        showDialog[index] = true;
                                                                        setShowDialog([...showDialog]);
                                                                    }}>
                                                                </img>
                                                                <div onClick={() => {
                                                                    showDialog[index] = true;
                                                                    setShowDialog([...showDialog]);
                                                                    // window.location.replace("https://voicefilter-stg.ai.hinet.net/index.html?from=h") 
                                                                }}>
                                                                    {((cookies.get("auth_access_token") === undefined || cookies.get("auth_access_token") === "") ? "立即體驗" : "立即體驗")
                                                                    }</div>
                                                            </>
                                                            :
                                                            <>
                                                                <img src={require("../../image/btn_promo.png").default} alt="instruction" width="50%" height="40px"
                                                                    onClick={() => {
                                                                        showDialog[index] = true;
                                                                        setShowDialog([...showDialog]);
                                                                    }}>
                                                                </img>
                                                                <div onClick={() => {
                                                                    showDialog[index] = true;
                                                                    setShowDialog([...showDialog]);
                                                                }}>
                                                                    {((cookies.get("auth_access_token") === undefined || cookies.get("auth_access_token") === "") ? "登入訂閱" : "立即訂閱")}</div>
                                                            </>
                                                        }
                                                    </Col> :
                                                    <>
                                                        <Col style={{ cursor: "pointer" }} xs={7} ><img src={require("../../image/btn_promo.png").default} alt="instruction" width="70%" height="40px"
                                                            onClick={() => {
                                                                showDialog[index] = true;
                                                                setShowDialog([...showDialog]);
                                                            }}>
                                                        </img>
                                                            <div style={{ width: "70%" }} onClick={() => {
                                                                showDialog[index] = true;
                                                                setShowDialog([...showDialog]);
                                                            }

                                                            }>{(cookies.get("auth_access_token") === undefined || cookies.get("auth_access_token") === "") ? "登入訂閱" : "立即訂閱"}</div>
                                                        </Col>
                                                    </>}
                                            </Row>
                                        </div>
                                    </Col>
                                )}
                            </Row>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "20px", fontWeight: "700" }}>
                        <p id="ent_notice"></p>
                    </Row></> : <></>}
        </div>
    )
    //{listItems.map((item, index ) => <li key={index} ><Link to={item.link}><img src={require("../../"+item.name).default} alt={item.name}></img></Link></li>)}
}
let Promoplan = (props) => {
    // console.log("promoplan curEnt "+JSON.stringify(props.curEnt));
    return (
        <PlanItem curEnt={props.curEnt} setPromoplainObj={props.setPromoplainObj} />
    )
}

export default Promoplan;